import { Controller } from '@hotwired/stimulus'
import { KeyboardScene } from '../utils/keyboard-scene/index.js'

export default class extends Controller {
  static values = { yamlPath: String, casePath: String, boardPath: String, rotationPath: String, keyMap: Array, rows: Number, columns: Number, thumbKeys: Number }

  connect () {
    this.initPreview()
  }

  disconnect () {
    if (this.keyboardScene) {
      this.keyboardScene.dispose()
    }
  }

  async initPreview () {
    if (!this.element) {
      throw new Error('Controller element not found')
    }

    if (!this.yamlPathValue) {
      this.showError('YAML path is required')
      return
    }

    if (!this.casePathValue) {
      this.showError('Case path is required')
      return
    }

    if (!this.boardPathValue) {
      this.showError('Board path is required')
      return
    }

    if (!this.keyMapValue || this.keyMapValue.length === 0) {
      this.showError('Key map is required')
      return
    }

    if (!this.rowsValue || this.rowsValue < 1) {
      this.showError('Valid number of rows is required')
      return
    }

    if (!this.columnsValue || this.columnsValue < 1) {
      this.showError('Valid number of columns is required')
      return
    }

    this.keyboardScene = new KeyboardScene(this.element, {
      yamlPath: this.yamlPathValue,
      casePath: this.casePathValue,
      boardPath: this.boardPathValue,
      rotationPath: this.rotationPathValue || '',
      keyMap: this.keyMapValue,
      rows: this.rowsValue,
      columns: this.columnsValue,
      thumbKeys: this.thumbKeysValue
    })

    try {
      await this.keyboardScene.init()
    } catch (error) {
      this.showError(`Failed to initialize keyboard preview: ${error.message}`)
    }
  }

  showError (message) {
    this.element.innerHTML = `<div class="p-4 text-red-600 bg-red-50 border border-red-200 rounded">${message}</div>`
  }
}
